import React from 'react';
import './Skills.css';

const Skills = () => {
  return (
    <section id="skills" className="sec">
      <div className="sec-inner">
        <div className="sec-label">03 — Skills</div>
        <h2 className="sec-title">Tools I actually<br/><em>ship with</em></h2>
        <div className="skills-layout reveal">
          <div className="skill-col">
            <div className="skill-col-head">Frontend</div>
            <div className="skill-item"><span className="skill-item-name">React.js</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">Next.js</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">TypeScript</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">Tailwind CSS</span><span className="skill-dot med"></span></div>
            <div className="skill-item"><span className="skill-item-name">HTML5 / CSS3</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">Responsive UI</span><span className="skill-dot"></span></div>
          </div>
          <div className="skill-col">
            <div className="skill-col-head">Backend</div>
            <div className="skill-item"><span className="skill-item-name">Node.js + Express</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">Laravel (PHP)</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">FastAPI (Python)</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">Spring Boot</span><span className="skill-dot med"></span></div>
            <div className="skill-item"><span className="skill-item-name">REST API Design</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">JWT · RBAC · OAuth</span><span className="skill-dot"></span></div>
          </div>
          <div className="skill-col">
            <div className="skill-col-head">Data · ML · DevOps</div>
            <div className="skill-item"><span className="skill-item-name">MongoDB · MySQL · PostgreSQL</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">Prisma ORM</span><span className="skill-dot med"></span></div>
            <div className="skill-item"><span className="skill-item-name">Python · Deep Learning</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">CNN · Ensemble Methods</span><span className="skill-dot"></span></div>
            <div className="skill-item"><span className="skill-item-name">Docker · GitHub Actions</span><span className="skill-dot med"></span></div>
            <div className="skill-item"><span className="skill-item-name">Jira · Agile / Scrum</span><span className="skill-dot"></span></div>
          </div>
        </div>
        <div className="skill-legend reveal">
          <span><span className="skill-dot" style={{display:'inline-block',verticalAlign:'middle',marginRight:'.4rem'}}></span> Expert</span>
          <span><span className="skill-dot med" style={{display:'inline-block',verticalAlign:'middle',marginRight:'.4rem'}}></span> Proficient</span>
        </div>
      </div>
    </section>
  );
};

export default Skills;
